import "./Schedule.css";
import React, { useEffect } from "react";

const Schedule = () => {
  useEffect(() => {
    const callback = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("timelineAnimation");
          document
            .querySelectorAll(".container, .container-mobile")
            .forEach((container) =>
              container.classList.add("timelineAnimationContainer")
            );
        }
      });
    };

    const options = {
      threshold: 0.2,
    };
    const observer = new IntersectionObserver(callback, options);
    const divs = document.querySelectorAll("#timeline");
    divs.forEach((div) => observer.observe(div));
  });
  return (
    <React.Fragment>
        <section id="schedule">
      <div className="mainSchedule" id="schedule">
        <div className="parent-schedule">
          <div className="schedule-title">
            Timeline
          </div>
          <div className="timeline" id="timeline">
            <div className="container" id="timeline-container">
              <h2 className="date">
                <div>
                  DEC
                  <div>
                    <div> 1</div> <div>st</div>
                  </div>
                </div>
              </h2>
              <h2 className="container-title">Registration opens</h2>
              <p className="container-description">
              Claim your spot at UIT's event bonanza! Register for the 48-hour hackathon, fashion show, and other thrilling activities. Seize the opportunity now! #ASTITVA
              </p>
              <span className="circle"></span>
            </div>
            <div className="container ">
              <h2 className="container-title">Details Submission</h2>
              <h1 className="date">
                <div>
                  Dec
                  <div>
                    <div>1</div> <div>st</div>
                  </div>
                  --Dec
                  <div>
                    <div>15</div> <div>th</div>
                  </div>
                </div>
              </h1>
              <p className="container-description">
              Calling innovators! Submit your abstracts for our 24-hour hackathon. Showcase your coding, cultural, or gaming brilliance. Exciting prizes await! Share your ideas—submit now. 
              </p>
              <span className="circle"></span>
            </div>
            <div className="container ">
              <h1 className="date">
                <div>
                  Dec
                  <div>
                    <div>15</div> <div>th</div>
                  </div>
                </div>
              </h1>
              <h2 className="container-title">Registration Closes</h2>
              <p className="container-description">
                Last call for registration! Time is running out to be a part of
                our extraordinary hackathon event. Don't miss this incredible
                opportunity to join a community of tech enthusiasts, developers,
                and innovators from around the world. Registration will close
                soon, so act fast and secure your spot
              </p>

              <span className="circle"></span>
            </div>
            <div className="container ">
              <h2 className="container-title">Audition</h2>
              <h1 className="date">
                <div>
                  Dec
                  <div>
                    <div>15-18</div> <div>th</div>
                  </div>
                </div>
              </h1>
              <p className="container-description">
                Step into the limelight – the moment we've all been waiting for
                is here! We're thrilled to announce the finalists of our highly
                competitive hackathon event. After meticulous evaluation and
                deliberation, we've handpicked the most promising and innovative
                teams to move forward to the final round
              </p>
              <span className="circle"></span>
            </div>

            <div className="container ">
              <h2 className="container-title">Finale</h2> <br />
              <h1 className="date">
                <div>
                  Dec
                  <div>
                    <div>21th</div> <div>th</div>
                  </div>
                  - Dec
                  <div>
                    <div>22</div> <div>th</div>
                  </div>
                </div>
              </h1>
              <p className="container-description">
                Get ready for the moment of triumph – the Hackathon Finale is
                just around the corner! After an intense and exhilarating
                journey, we've arrived at the grand finale, where the most
                ingenious minds will showcase their remarkable solutions.
              </p>
              <span className="circle"></span>
            </div>
            <div className="container ">
              <h2 className="container-title">Award Ceremony</h2>
              <h1 className="date">
                <div>
                  Dec
                  <div>
                    <div>22</div> <div>th</div>
                  </div>
                </div>
              </h1>
              <p className="container-description">
                The judges deliberate, and winners are announced in various
                categories, celebrating outstanding projects, creativity, and
                teamwork. The successful conclusion of the hackathon is
                commemorated with an awards ceremony and well-deserved
                celebrations.
              </p>
              <span className="circle"></span>
            </div>
          </div>
        </div>
      </div>
      <div className="mainSchedule" id="schedule">
        <div className="parent-schedule-mobile">
          <div className="schedule-title-mobile">

            Timeline
          </div>
          <div className="timeline-mobile" id="timeline">
            <div className="container-mobile" id="timeline-container">
              <h2 className="container-title-mobile">Registration opens</h2>{" "}
              <h2 className="date-mobile">
                <div>
                  Dec
                  <div>
                    <div>1</div> <div>Dec</div>
                  </div>
                </div>
              </h2>
              <p className="container-description-mobile">
              Last call for registration! Time is running out to be a part of
                our extraordinary hackathon event. Don't miss this incredible
                opportunity to join a community of tech enthusiasts, developers,
                and innovators from around the world. Registration will close
                soon, so act fast and secure your spot
              </p>
              <span className="circle-mobile"></span>
            </div>
            <div className="container-mobile" id="timeline-container">
              <h2 className="container-title-mobile">Detail Submission</h2>
              <h1 className="date-mobile">
                {" "}
                <div>
                  Dec
                  <div>
                    <div>1</div> <div>st</div>
                  </div>
                  -Dec
                  <div>
                    <div>-15</div> <div>th</div>
                  </div>
                </div>
              </h1>
              <p className="container-description-mobile">
                Submit your abstracts and be a part of the forefront of
                innovation! We invite you to share your groundbreaking ideas and
                research at our esteemed hackathon event. This is your
                opportunity to present your unique insights and solutions 🚀👩‍💻
              </p>
              <span className="circle-mobile "></span>
            </div>
            <div className="container-mobile ">
              <h2 className="container-title-mobile">Audition</h2>
              <h1 className="date-mobile">
                <div>
                  Dec
                  <div>
                    <div>15-18</div> <div>th</div>
                  </div>
                </div>
              </h1>
              <p className="container-description-mobile">
                Step into the limelight – the moment we've all been waiting for
                is here! . After meticulous evaluation and
                deliberation, we've handpicked the most promising and innovative
                teams to move forward to the final round
              </p>
              <span className="circle-mobile"></span>
            </div>
            <div className="container-mobile">
              <h2 className="container-title-mobile">Registration Closes</h2>
              <h1 className="date-mobile">
                <div>
                  Dec
                  <div>
                    <div>15</div> <div>th</div>
                  </div>
                </div>
              </h1>
              <p className="container-description-mobile">
                Last call for registration! Time is running out to be a part of
                our extraordinary hackathon event. Don't miss this incredible
                opportunity to join a community of tech enthusiasts, developers,
                and innovators from around the world. Registration will close
                soon, so act fast and secure your spot
              </p>
              <span className="circle-mobile"></span>
            </div>
            <div className="container-mobile ">
              <h2 className="container-title-mobile">Finale</h2>{" "}
              <br />
              <h1 className="date-mobile">
                <div>
                  dec
                  <div>
                    <div>21</div> <div>th</div>
                  </div>
                  - dec
                  <div>
                    <div>22</div> <div>th</div>
                  </div>
                </div>
              </h1>
              <p className="container-description-mobile">
                Get ready for the moment of triumph – the Hackathon Finale is
                just around the corner! After an intense and exhilarating
                journey, we've arrived at the grand finale, where the most
                ingenious minds will showcase their remarkable solutions.
              </p>
              <span className="circle-mobile"></span>
            </div>
            <div className="container-mobile ">
              <h2 className="container-title-mobile">Award Ceremony</h2>
              <h1 className="date-mobile">
                <div>
                  dec
                  <div>
                    <div>22</div> <div>th</div>
                  </div>
                </div>
              </h1>
              <p className="container-description-mobile">
                The judges deliberate, and winners are announced in various
                categories, celebrating outstanding projects, creativity, and
                teamwork. The successful conclusion of the hackathon is
                commemorated with an awards ceremony and well-deserved
                celebrations.
              </p>
              <span className="circle-mobile"></span>
            </div>
          </div>
        </div>
      </div>
      </section>
    </React.Fragment>
  );
};

export default Schedule;